import React, { useState, useRef } from 'react';
import { UploadIcon, EditIcon } from 'lucide-react';
export function FileUpload({
  onFileUpload,
  documentTypes = ['Invoice', 'Purchase Order', 'Quote', 'Contract', 'Specification', 'Other'],
  defaultDocumentType = ''
}) {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState(defaultDocumentType || (documentTypes.length > 0 ? documentTypes[0] : ''));
  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processFiles(Array.from(e.dataTransfer.files));
    }
  };
  const handleChange = e => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      processFiles(Array.from(e.target.files));
    }
  };
  const processFiles = files => {
    // Add the document type to each file
    const filesWithType = files.map(file => ({
      file,
      documentType: selectedDocumentType,
      name: file.name,
      size: file.size,
      uploadDate: new Date().toISOString()
    }));
    onFileUpload(filesWithType);
  };
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleDocumentTypeChange = e => {
    setSelectedDocumentType(e.target.value);
  };
  return <div className="space-y-3" data-id="element-7991">
      {documentTypes.length > 0 && <div data-id="element-7992">
          <label htmlFor="documentType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-7993">
            Document Type
          </label>
          <select id="documentType" value={selectedDocumentType} onChange={handleDocumentTypeChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" data-id="element-7994">
            {documentTypes.map(type => <option key={type} value={type} data-id="element-7995">
                {type}
              </option>)}
          </select>
        </div>}
      <div className={`border-2 border-dashed rounded-md p-6 flex flex-col items-center justify-center ${dragActive ? 'border-indigo-500 bg-indigo-50' : 'border-gray-300'}`} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop} data-id="element-7996">
        <div className="text-center" data-id="element-7997">
          <UploadIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-7998" />
          <div className="mt-2" data-id="element-7999">
            <p className="text-sm text-gray-600" data-id="element-8000">
              Drag and drop files here, or
              <button type="button" className="ml-1 text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline" onClick={handleButtonClick} data-id="element-8001">
                browse
              </button>
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-8002">
              Upload documents (PDF, DOCX, XLSX, up to 10MB each)
            </p>
          </div>
        </div>
        <input ref={fileInputRef} type="file" multiple onChange={handleChange} className="hidden" data-id="element-8003" />
      </div>
    </div>;
}